<template>
    <div class="container">
        <!-- 主内容区域 -->
        <main-content  ref="mainContent">  </main-content>
        <div class="deliver-container">
            <div class="deliver-btn2">
                <el-button size="mini" class="greybtn" style="width: 70px;" @click="goBack">返回</el-button>
            </div>
            <div class="deliver-btn">
                <el-button size="mini" class="bluebtn" @click="submitForm">提交</el-button>
            </div>
            <h4 style="margin: 50px 0 10px 30px;text-align: left">查看订单详情</h4>
            <div class="table-box">
                <el-form :model="orderArr" :rules="orderArrRules" ref="orderArrForm" class="add-list-form" label-width="100px">
                    <p class="cootitle">销售订单--基础信息</p>
                    <div class="overflow">
                        <div class="float-left div-css">
                            <el-form-item label="销售订单号">
                                {{this.dataForm.order_sn}}
                            </el-form-item>
                            <el-form-item label="下单时间">
                                <el-input v-model="this.dataForm.payment_at" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="颜色&款式">
                                <el-input v-model="this.dataForm.attr" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="物流运单号">
                                <el-input v-model="this.dataForm.express_number" disabled></el-input>
                            </el-form-item>
                        </div>
                        <div class="float-left div-css div-css-left">
                            <el-form-item label="订单状态">
                                <el-select v-model="this.dataForm.status" disabled style="width:100%;">
                                    <el-option key="" label="全部" value=""></el-option>
                                    <el-option
                                            v-for="item in statusArr"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="商品件数" prop="total_num">
                                <el-input v-model="this.dataForm.total_num" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="配送方式" prop="type">
                                <el-select v-model="this.dataForm.type" disabled style="width:100%;">
                                    <el-option
                                            v-for="item in typeArr"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="物流公司">
                                <el-input v-model="this.dataForm.express_company" disabled></el-input>
                            </el-form-item>
                        </div>
                        <div class="float-left div-css div-css-left">
                            <el-form-item label="支付方式">
                                <el-input v-model="this.method" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="支付积分">
                                <el-input v-model="this.dataForm.total" disabled> 积分</el-input>
                            </el-form-item>
                            <el-form-item label="绑定店铺">
                                <el-input v-if="this.dataForm.get_shop_info" v-model="this.dataForm.get_shop_info.name" disabled></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="overflow">
                        <el-form-item label="自提门店地址">
                            <el-input v-if="this.dataForm.shop_addr" v-model="this.dataForm.shop_addr" disabled style="width: 57.5%"></el-input>
                        </el-form-item>
                    </div>
                    <p class="cootitle">销售订单--客户信息</p>
                    <div class="overflow">
                        <div class="float-left div-css">
                            <el-form-item label="客户编码">
                                <el-input v-model="this.customerArr.code" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="账户积分">
                                <el-input v-model="this.customerArr.integral" disabled></el-input>
                            </el-form-item>
                        </div>
                        <div class="float-left div-css div-css-left">
                            <el-form-item label="客户姓名">
                                <el-input v-model="this.customerArr.name" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="昵称">
                                <el-input v-model="this.customerArr.nick_name" disabled></el-input>
                            </el-form-item>
                        </div>
                        <div class="float-left div-css div-css-left">
                            <el-form-item label="手机号码">
                                <el-input v-model="this.customerArr.tel" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="性别">
                                <el-select v-model="this.customerArr.sex" disabled style="width:100%;">
                                    <el-option
                                            v-for="item in sexArr"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                    <p class="cootitle">销售订单--收货人信息</p>
                    <div class="overflow">
                        <div class="float-left div-css">
                            <el-form-item label="收货人姓名">
                                <el-input v-model="orderArr.consignee_name" auto-complete="off" style="width: 100%" ></el-input>
                            </el-form-item>
                            <el-form-item label="手机号码">
                                <el-input v-model="orderArr.tel" auto-complete="off" style="width: 100%"></el-input>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="overflow">
                        <el-form-item label="详细地址" prop="description">
                            <el-input v-model="orderArr.address" style="width:57.5%" auto-complete="off"></el-input>
                        </el-form-item>
                    </div>
                    <p class="cootitle">销售订单--订单信息</p>
                    <div class="table-container" style="width: 97%;margin-left: 1.5%">
                        <el-table border :data="tableGoods" :header-cell-style="{backgroundColor:'#ccc', 'text-align':'center'}" :cell-style="{'text-align':'center'}">
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column label="商品图片" prop="snap_img" min-width="120">
                                <template slot-scope="scope">
                                    <img v-if="scope.row.snap_img" :src="doMain + scope.row.snap_img" alt="" style="width: 60px;height: 60px;">
                                </template>
                            </el-table-column>
                            <el-table-column label="商品编码" prop="upc" min-width="120"></el-table-column>
                            <el-table-column label="商品名称" prop="name" min-width="400"></el-table-column>
                            <el-table-column label="兑换积分" prop="price" min-width="90"></el-table-column>
                            <el-table-column label="数量" prop="num" min-width="100"></el-table-column>
                            <el-table-column label="小计" prop="price" min-width="100">
                                <template slot-scope="scope">
                                    <label>{{scope.row.num * scope.row.price}}</label>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import MainContent from "../MainContent/MainContent"
    import Cookies from "js-cookie"
    export default {
        components: {
            MainContent
        },
        data(){
            return {
                method: '积分兑换',
                statusArr:[{
                    id: 1,
                    name: '待支付'
                },{
                    id: 2,
                    name: '已支付'
                },{
                    id: 3,
                    name: '拣货中'
                },{
                    id: 4,
                    name: '已发货'
                },{
                    id: 5,
                    name: '申请退款'
                },{
                    id: 6,
                    name: '已退款'
                },{
                    id: 0,
                    name: '已废弃'
                }],
                dataForm: {},
                tableGoods: [],
                customerArr: [],
                orderArr: {
                    order_sn: '',
                    consignee_name: '',
                    tel: '',
                    province: '',
                    city: '',
                    area: '',
                    address: ''
                },
                typeArr:[{
                    id: 1,
                    name: '自提'
                },{
                    id: 2,
                    name: '邮寄'
                }],
                sexArr:[{
                    id: 1,
                    name: '男'
                },{
                    id: 2,
                    name: '女'
                }],

                doMain:this.global.backDoMain,
                orderArrRules: {
                    consignee_name: [
                        { required: true, message: '请输入收货人姓名', trigger: 'blur' }
                    ],
                    tel: [
                        { required: true, message: '请输入收货人电话', trigger: 'blur' }
                    ],
                },
                provinceArr:[],
            }
        },
        methods: {
            findPage() {
                var order_sn = this.$route.query.params.order_sn
                this.$api.orders.getFirst({'order_sn': order_sn}).then((res) => {
                    this.tableGoods = res.data.info.get_order_detail
                    this.dataForm = res.data.info
                    this.customerArr = res.data.info.get_customer
                    this.provinceArr = res.data.provinceArr

                    this.orderArr.order_sn = this.dataForm.order_sn
                    this.orderArr.consignee_name = this.dataForm.consignee_name
                    this.orderArr.tel = this.dataForm.tel
                    this.orderArr.province = this.dataForm.province
                    this.orderArr.city = this.dataForm.city
                    this.orderArr.area = this.dataForm.area
                    this.orderArr.address = this.dataForm.address
                })
            },
            submitForm() {
                this.$refs.orderArrForm.validate((valid) => {
                    if (valid) {
                        let params = Object.assign({}, this.orderArr)
                        this.$api.orders.save(params).then((res) => {
                            if(res.code == 200) {
                                this.$message({ message: '编辑成功', type: 'success' })
                                this.$router.go(-1);
                                this.$refs.mainContent.tabsCloseCurrentHandle();
                            } else if (res.code == 302) {
                                this.$message({
                                    message: res.message,
                                    type: "error"
                                });
                            } else {
                                this.$message({message: res.message, type: 'error'})
                            }
                        })
                    }
                })
            },
            goBack() {
                this.$router.go(-1);
                this.$refs.mainContent.tabsCloseCurrentHandle();
            }
        },
        mounted() {
            this.findPage()
        },
        computed: {
            headers() {
                return{
                    "Authorization": Cookies.get('token') // 直接从本地获取token就行
                }
            }
        },
    }
</script>

<style lang="scss">
    @import "../../assets/base/deliver.css";
    .deliver-container{
        padding: 0 20px 20px 20px;
    }
    .deliver-btn{
        text-align: right;
        position: fixed;
        right: 20px;
        top: 70px;
        z-index: 999;
    }
    .deliver-btn2{
        position: fixed;
        left: 190px;
        top: 70px;
        z-index: 999;
    }
    .cootitle {
        height: 20px;
        line-height: 20px;
        border-bottom: 1px solid #ccc;
        font-size: 14px;
        margin-bottom: 10px;
        margin-top: 10px;
    }
    .subtitle-div{
        width: 100%;
        margin-top: 20px;
    }
    .div-css{
        width: 24%;
    }
    .div-css-left{
        margin-left: 12.5%;
    }
    .add-list-form {
        margin: 0 65px 20px 75px;
    }
    .el-input__inner{
        color: black!important;
        background-color: white!important;
    }

</style>


// WEBPACK FOOTER //
// src/views/Order/Edit.vue